export default {
  2015: { video: 'bg_2015' },
  2016: { video: null },
  2017: { video: 'bg_2017' },
  2018: { video: 'bg_2018' },
  2019: { video: 'bg_2019' },
  2020: { video: 'bg_2020' },
  2021: { video: 'bg_2021' },
  2022: { video: 'bg_2022' },
  2023: { video: 'bg_2023' },
}
